import { PanayaRoutes } from '@frontend-site/shared/router-store';

export const OLD_UI_REDIRECT_ROUTES: PanayaRoutes = [
    {
        path: 'tm/:projectId/ia/myCorrections',
        redirectTo: '/:projectId/corrections/my-corrections',
        pathMatch: 'full'
    },
    {
        path: 'tm/:projectId/releaseDynamix/:companyId/project/general',
        redirectTo: '/:projectId/overview/project-details',
        pathMatch: 'full'
    }
];
